define('legacy/navigation',['module', 'legacy/yui-2.9.0-combo', 'all/pretty-links', 'all/player/session'], function(module, YAHOO, prettyLinks, session) {
	'use strict';

	var configuration = module.config();
	var locale = configuration.locale.toLowerCase();

	window.setBodyFrameSrc = function(inFlow) {
		window.top.handlePageActivePageChange(inFlow);
		if (inFlow == 'Poker' || inFlow == 300) {
			window.top.changeBg('bg-poker');
		} else if (inFlow == 'Casino' || inFlow == 400) {
			window.top.changeBg('bg-casino');
		} else if (inFlow == 'Sportsbook' || inFlow == 500) {
			window.top.changeBg('bg-sportsbook');
		} else if (inFlow == 50 || inFlow == 'Home') {
			window.top.changeBg('bg-startsportsbook');
		} else {
			window.top.changeBg('bg-contentpages');
		}
	};

	window.handlePageActivePageChange = function(e) {
		YAHOO.log('handlePageActivePageChange: ' + e);
		var newState, currentState;

		newState = e; // Name of the state
		YAHOO.log('newState: ' + newState);
		try {
			currentState = YAHOO.util.History.getCurrentState('page');
			YAHOO.log('currentState: ' + currentState);
			// The following test is crucial. Otherwise, we end up circling forever.
			// Indeed, YAHOO.util.History.navigate will call the module
			// onStateChange
			// callback, which will call tabView.set, which will call this handler
			// and it keeps going from here...
			if (newState != currentState) {
				// Linus added. For solving white page bug in ie chrome. Each loaded
				// page need to set style to block again on
				// DOMReady
				if (newState != 'Sportsbook' && newState != '500') {
					window.top.document.getElementById('bodyframe').style.display = 'none';
					window.top.document.getElementById('footer').style.display = 'none';
				}
				YAHOO.log('navigate to: ' + newState);
				/* alert('before navigate'); */
				YAHOO.util.History.navigate('page', newState);
				/* alert('after navigate'); */
				var frame = window.top.document.getElementById('bodyframe');
				if (newState != 'Sportsbook' && newState != '500'
					&& currentState != 'Sportsbook' && currentState != '500') {
					frame.style.height = frame.contentWindow.document.body.scrollHeight
						+ 'px';
				} else if (newState == 'Sportsbook' || newState == '500') {
					frame.style.height = '0px';
					window.top.document.getElementById('sb-spin-fl').style.display = 'block';
				}
			} else if (newState == 'Sportsbook' || newState == '500'
				|| newState == 'Casino' || newState == '400'
				|| newState == 'Poker' || newState == '300') {
				if (newState != 'Sportsbook' && newState != '500') {
					window.top.document.getElementById('bodyframe').style.display = 'none';
					window.top.document.getElementById('footer').style.display = 'none';
				}
				window.top.document.getElementById('bodyframe').src = '/pp?flow='
					+ newState;
				var bodyframe = window.top.document.getElementById('bodyframe');
				if (newState != 'Sportsbook' && newState != '500') {
					bodyframe.style.height = bodyframe.contentWindow.document.body.scrollHeight
						+ 'px';
				} else {
					bodyframe.style.height = '1px';
					window.top.document.getElementById('sb-spin-fl').style.display = 'block';
				}
			}
		} catch (e) {
			window.top.document.getElementById('bodyframe').src = '/pp?flow='
				+ newState;
		}
	};

	window.showHiddenObjects = function() {
		// Need this to show page after fix for problem with white pages ie chrome
		var bodyFrame = window.top.document.getElementById('bodyframe');
		if (bodyFrame != null) {
			bodyFrame.style.display = 'block';
		}

		// Need this to fix so that the footer isn't shown before page is loaded.
		var footer = window.top.document.getElementById('footer');
		if (footer !== null) {
			footer.style.display = 'block';
		}
	};

	window.loadUrl = function(inUrl, inTarget) {
		if (inTarget == null || inTarget == 'mainframe') {
			if (inUrl != null) {
				window.top.location.href = inUrl;
			} else {
				window.top.location.reload();
			}
		} else {
			var iframes = window.top.frames;
			for (var i = 0; i < iframes.length; i++) {
				try {
					var item = iframes[i].name;
					if (item == inTarget) {
						if (inUrl != null) {
							// Assuming that bodyframe is the iframe
							setBodyFrameSrc(inUrl);
						} else {
							iframes[i].location.reload();
						}
						break;
					}
				} catch (e) {
					// Do nothing
				}
			}
		}
	};

	window.changeBg = function(inBg) {
		var theBody = window.top.document.getElementsByTagName('body')[0];
		theBody.id = inBg + '-' + locale;
		return false;
	};

	window.cancelRelogin = function() {
		var gotoUrl = getCookie('lastProduct');
		if (gotoUrl) {
			gotoUrl = gotoUrl.replace('"', '');
			gotoUrl = gotoUrl.replace('"', '');
			window.top.location.href = gotoUrl;
		} else {
			window.top.location.href = location.protocol + '//' + location.host;
		}
	};

	function getCookie(cookieName) {
		var results = document.cookie.match('(^|;) ?' + cookieName + '=([^;]*)(;|$)');
		if (results) {
			return (unescape(results[2]));
		}
		else {
			return null;
		}
	}

	window.reInitPage = function() {
		window.location.reload();
	};
	window.reInitUserBar = function() {
	};

	window.getDid = function() {
		if (window.getSWF('swftopnav')) {
			try {
				return window.getSWF('swftopnav').getDid();
			} catch (e) {
				return null;
			}
		}
		return null;
	};

	window.getSWF = function(movieName) {
		if (navigator.appName.indexOf('Microsoft') !== -1) {
			return window[movieName];
		} else {
			return document[movieName];
		}
	};

	window.loadMyPage = function() {
		window.location.href = prettyLinks.getLink('MyPages');
	};

	// TODO: only used in StartPageTopFlash, remove when startpage is gone
	window.browseToProduct = function(inProduct) {
		window.location.href = inProduct;
	};

	window.reSizeBodyFrame = function(inHeight) {
		if (inHeight) {
			var iframeElement = document.getElementById('bodyframe');
			if (iframeElement) {
				if (navigator.appName === 'Microsoft Internet Explorer') {
					iframeElement.style.height = inHeight + 'px';
				} else if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
					var chromeHeight = inHeight;
					iframeElement.style.height = (parseInt(chromeHeight, 10) + 80) + 'px';
				} else {
					iframeElement.style.height = inHeight + 'px';
				}
			}
		} else {
			var f = window.top.document.getElementById('bodyframe');
			if (f) {
				f.style.height = (f.contentWindow.document.body.scrollHeight + 40) + 'px';
			}
		}
		if (window.top.document.getElementById('sb-spin-fl') && window.top.document.getElementById('sb-spin-fl').style.display !== 'none') {
			window.top.document.getElementById('sb-spin-fl').style.display = 'none';
		}
	};

	window.getTopWindowFocus = function() {
		var topWindow = window.top;
		if (topWindow) {
			topWindow.focus();
		}
	};

	window.resizeIframe = function(inHeight) {
		var iframeElement = document.getElementById('bodyframe');
		iframeElement.style.height = inHeight + 'px';
		// Call keep alive function if logged in
	};

	window.resizeIframeInit = function(iframeId, inHeight) {
		var $iframe = $('#'+iframeId);
        if (inHeight>1){
            $iframe.height(inHeight);
        }
		$('#sb-spin-fl').hide();

		// Call keep alive function if logged in
		if (session.authenticated) {
			$.get('/pp?flow=empty');
		}
	};
});

